import { render } from "./vshoppluswecom.vue?vue&type=template&id=67ad8d18&scoped=true"
import script from "./vshoppluswecom.vue?vue&type=script&lang=js"
export * from "./vshoppluswecom.vue?vue&type=script&lang=js"

import "./vshoppluswecom.vue?vue&type=style&index=0&id=67ad8d18&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ad8d18"]])

export default __exports__